import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Enlightenment_&_Revolutions_-_Haitian_Revolution.png';

function HistoryPageHaitianRevolutionGo() {
  return (
    <QuizPage
      title="History: Haitian Revolution"
      subTopic="Haitian Revolution"
      backgroundImage={historyImage}
      returnPath="/History-Haitian-Revolution"
    />
  );
}

export default HistoryPageHaitianRevolutionGo;
